import Vue from 'vue';
import Router from 'vue-router';
import { trackNavigation, trackPageView, trackContent } from './services/analytics';
import Index from './views/index.vue';
import Dashboard from './views/Dashboard/index.vue';

Vue.use(Router);

function isAuthenticated() {
    return !!localStorage.getItem('authToken');
}

const router = new Router({
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }
        if (to.hash) {
            return {
                selector: to.hash,
            };
        }
        return { x: 0, y: 0 };
    },

    routes: [
        {
            path: '/',
            name: 'home',
            beforeEnter: (to, from, next) => {
                if (isAuthenticated()) {
                    next({ path: '/dashboard' });
                } else {
                    next();
                }
            },
            component: Index,
            meta: {
                transitionName: 'slide',
            },
        },
        {
            path: '/reset-password',
            name: '',
            component: () => import('./views/PasswordReset.vue'),
            meta: {
                transitionName: 'slide',
            },
        },
        {
            path: '/verify-mail',
            name: '',
            component: () => import('./views/Email.vue'),
            meta: {
                transitionName: 'slide',
            },
        },
        {
            path: '/register',
            name: 'register',
            component: () => import('./views/Register.vue'),
            meta: {
                transitionName: 'slide',
            },
        },
        {
            path: '/promotion',
            name: 'promotion',
            component: () => import('./views/PromotionLanding.vue'),
            meta: {
                title: 'TaxiFusion Sonderaktion - 50% Rabatt + kostenloses Terminal',
                description:
                    'Sichern Sie sich 50% Rabatt auf TaxiFusion und erhalten Sie das myPOS Go 2 Terminal kostenlos. TSE-konforme Flottenmanagement-Software für Taxiunternehmen.',
                transitionName: 'slide',
            },
        },
        {
            path: '/lvbtm',
            name: 'lvbtmRegister',
            component: () => import('./views/LVBTMRegister.vue'),
            meta: {
                transitionName: 'slide',
            },
        },
        {
            path: '/impressum',
            name: 'impressum',
            component: () => import('./views/Impressum.vue'),
            meta: {
                transitionName: 'slide',
            },
        },
        {
            path: '/terms-of-service',
            name: 'termsOfService',
            component: () => import('./views/Terms.vue'),
            meta: {
                transitionName: 'slide',
            },
        },
        {
            path: '/privacy-policy',
            name: 'privacyPolicy',
            component: () => import('./views/PrivacyPolicy.vue'),
            meta: {
                transitionName: 'slide',
            },
        },
        {
            path: '/webinar',
            name: 'webinarRegistration',
            component: () => import('./views/WebinarRegistration.vue'),
            meta: {
                transitionName: 'slide',
            },
        },
        {
            path: '/mobile-app-redirect',
            name: 'appRedirect',
            component: () => import('./views/AppRedirect.vue'),
            meta: {
                transitionName: 'slide',
            },
        },
        {
            path: '/sign-in',
            name: 'login',
            component: () => import('./views/Login.vue'),
            meta: {
                transitionName: 'slide',
            },
        },
        {
            path: '/exclusive-offers',
            name: 'exclusiveOffers',
            component: () => import('./views/ExclusiveOffers.vue'),
            meta: {
                transitionName: 'slide',
                title: 'Exklusive Angebote | TaxiFusion Mitglieder',
                description:
                    'Exklusive Premium-Angebote für TaxiFusion Mitglieder: SitzExakt Sitzbezüge und AnyCover Oberflächenschutz mit bis zu 50% Rabatt.',
            },
        },
        {
            path: '/tse-checklist',
            name: 'tseChecklist',
            component: () => import('./views/TSEChecklist/index.vue'),
            meta: {
                transitionName: 'slide',
                title: 'TSE-Checkliste 2025/2026 | TaxiFusion - Alles was Sie wissen müssen',
                description:
                    'Umfassende TSE-Checkliste für Taxiunternehmen 2025/2026. Gesetzliche Anforderungen, technische Umsetzung, Belegpflicht und wichtige Fristen.',
            },
        },
        {
            path: '/contact',
            name: 'contact',
            component: () => import('./views/ContactPage.vue'),
            meta: {
                transitionName: 'slide',
                title: 'Kontakt | TaxiFusion - Fragen und Support',
                description:
                    'Kontaktieren Sie TaxiFusion für Fragen und Support. Unser Team hilft Ihnen gerne bei allen Anliegen rund um unsere Taxi-Software.',
            },
        },
        {
            path: '/demo',
            name: 'demo',
            component: () => import('./views/DemoRequestPage.vue'),
            meta: {
                transitionName: 'slide',
                title: 'Demo anfragen | TaxiFusion - Kostenlos testen',
                description:
                    'Vereinbaren Sie eine kostenlose Demo von TaxiFusion. Erleben Sie die Zukunft des Flottenmanagements live und lernen Sie alle Features kennen.',
            },
        },
        {
            path: '/mobile-contact',
            name: 'mobileContact',
            component: () => import('./views/MobileContactPage.vue'),
            meta: {
                transitionName: 'slide',
                title: 'Kontakt | TaxiFusion - Mobile',
                description:
                    'Kontaktieren Sie TaxiFusion für Fragen und Support. Optimiert für mobile Geräte.',
            },
        },
        {
            path: '/pricing',
            name: 'pricing',
            component: () => import('./views/PricingPage.vue'),
            meta: {
                transitionName: 'slide',
                title: 'Preise | TaxiFusion - Flexible Lösungen für Ihre Taxiflotte',
                description:
                    'Flexible Preise für TaxiFusion. Lite ab 10€/Monat, Basic ab 16€/Monat. TSE-konform und sofort einsatzbereit.',
            },
        },
        {
            path: '/features',
            name: 'features',
            component: () => import('./views/FeaturesPage.vue'),
            meta: {
                transitionName: 'slide',
                title: 'Features | TaxiFusion - Umfassende Taxi-Managementlösung',
                description:
                    'Entdecken Sie alle Features von TaxiFusion: Fahrzeugverfolgung, Fahrer-App, Echtzeit-Analysen, TSE-konform und cloud-basiert.',
            },
        },
        {
            path: '/einbauer',
            name: 'einbauerFinder',
            component: () => import('./views/EinbauerFinder.vue'),
            meta: {
                transitionName: 'slide',
                title: 'Einbauer Finder | TaxiFusion - Taxameter auf uns umstellen',
                description:
                    'Finden Sie zertifizierte Einbauer, die Ihr Taxameter auf TaxiFusion umstellen. Einfach Adresse eingeben und erfahren Sie, wer Ihr Taxameter programmiert.',
            },
        },
        {
            path: '/dashboard',
            name: 'Dashboard',
            component: () => import('./views/Dashboard/index.vue'),
            meta: {
                transitionName: 'slide',
                requiresAuth: true,
            },
            children: [
                {
                    path: '/onboarding',
                    name: 'onboarding',
                    component: () => import('./views/Dashboard/Onboarding/index.vue'),
                    meta: {
                        transitionName: 'slide',
                        requiresAuth: true,
                    },
                },
                {
                    path: '/academy',
                    name: 'dashboard-academy',
                    component: () =>
                        import(
                            /* webpackChunkName: "dashboard-academy" */ '@/views/Dashboard/Academy'
                        ),
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: '',
                    name: 'overview',
                    component: () => import('./views/Dashboard/Overview/index.vue'),
                    meta: {
                        transitionName: 'slide',
                        requiresAuth: true,
                    },
                },
                {
                    path: '/revenue',
                    name: 'revenue',
                    component: () => import('./views/Dashboard/Revenue/index.vue'),
                    meta: {
                        transitionName: 'slide',
                        requiresAuth: true,
                    },
                },
                {
                    path: '/analytics',
                    name: 'analytics',
                    component: () => import('./views/Dashboard/Analytics/index.vue'),
                    meta: {
                        transitionName: 'slide',
                        requiresAuth: true,
                    },
                },
                {
                    path: '/working-time',
                    name: 'working-time',
                    component: () => import('./views/Dashboard/Workingtime/index.vue'),
                    meta: {
                        transitionName: 'slide',
                        requiresAuth: true,
                    },
                },
                {
                    path: '/shifts',
                    name: 'shifts',
                    component: () => import('./views/Dashboard/Shifts/index.vue'),
                    meta: {
                        transitionName: 'slide',
                        requiresAuth: true,
                    },
                },
                {
                    path: '/trips',
                    name: 'trips',
                    component: () => import('./views/Dashboard/Trips/index.vue'),
                    meta: {
                        transitionName: 'slide',
                        requiresAuth: true,
                    },
                },
                {
                    path: '/employees',
                    name: 'employees',
                    component: () => import('./views/Dashboard/Employees/index.vue'),
                    meta: {
                        transitionName: 'slide',
                        requiresAuth: true,
                    },
                },
                {
                    path: '/schedular',
                    name: 'schedular',
                    component: () => import('./views/Dashboard/Schedular/index.vue'),
                    meta: {
                        transitionName: 'slide',
                        requiresAuth: true,
                    },
                },
                {
                    path: '/cars',
                    name: 'cars',
                    component: () => import('./views/Dashboard/Cars/index.vue'),
                    meta: {
                        transitionName: 'slide',
                        requiresAuth: true,
                    },
                },
                {
                    path: '/cars/:id',
                    name: 'car',
                    component: () => import('./views/Dashboard/Cars/Car/index.vue'),
                },
                {
                    path: '/driverslog',
                    name: 'driversLog',
                    component: () => import('./views/Dashboard/DriversLog/index.vue'),
                    meta: {
                        transitionName: 'slide',
                        requiresAuth: true,
                    },
                },
                {
                    path: '/operationride',
                    name: 'operationride',
                    component: () => import('./views/Dashboard/Operationride/index.vue'),
                    meta: {
                        transitionName: 'slide',
                        requiresAuth: true,
                    },
                },
                {
                    path: '/invoice',
                    name: 'invoice',
                    component: () => import('./views/Dashboard/Invoice/index.vue'),
                    meta: {
                        transitionName: 'slide',
                        requiresAuth: true,
                    },
                },
                {
                    path: '/settings',
                    name: 'settings',
                    component: () => import('./views/Dashboard/Settings/index.vue'),
                    meta: {
                        transitionName: 'slide',
                        requiresAuth: true,
                    },
                },
                {
                    path: '/changelog',
                    name: 'changelog',
                    component: () => import('./views/Dashboard/Changelog/index.vue'),
                    meta: {
                        transitionName: 'slide',
                        requiresAuth: true,
                    },
                },
                {
                    path: '/faq',
                    name: 'faq',
                    component: () => import('./views/Dashboard/Faq/index.vue'),
                    meta: {
                        transitionName: 'slide',
                        requiresAuth: true,
                    },
                },
                {
                    path: '/savings-calculator',
                    name: 'savings-calculator',
                    component: () => import('./views/Dashboard/SavingsCalculator/index.vue'),
                    meta: {
                        transitionName: 'slide',
                        requiresAuth: true,
                    },
                },
                {
                    path: '/card-payments',
                    name: 'card-payments',
                    component: () => import('./views/Dashboard/CardPayments/index.vue'),
                    meta: {
                        transitionName: 'slide',
                        requiresAuth: true,
                    },
                },
                {
                    path: '/savings-calculator/:id',
                    name: 'employee-revenue',
                    component: () =>
                        import('./views/Dashboard/SavingsCalculator/Employee/index.vue'),
                    meta: {
                        transitionName: 'slide',
                        requiresAuth: true,
                    },
                },
                {
                    path: '/calendar',
                    name: 'calendar',
                    component: () => import('./views/Dashboard/Calendar/index.vue'),
                    meta: {
                        transitionName: 'slide',
                        requiresAuth: true,
                    },
                },
                {
                    path: '/billing',
                    name: 'billing',
                    component: () => import('./views/Dashboard/Billing/index.vue'),
                    meta: {
                        transitionName: 'slide',
                        requiresAuth: true,
                    },
                },
                {
                    path: '/billing/statement',
                    name: 'billing-statement',
                    component: () => import('./views/Dashboard/Billing/Statement/index.vue'),
                    meta: {
                        transitionName: 'slide',
                        requiresAuth: true,
                    },
                },
                {
                    path: '/billing/profiles/:id?',
                    name: 'billing-profiles',
                    component: () => import('./views/Dashboard/Billing/Profiles/index.vue'),
                    meta: {
                        transitionName: 'slide',
                        requiresAuth: true,
                        title: 'Abrechnungsprofil',
                        description: 'Erstellen und Bearbeiten von Abrechnungsprofilen.',
                    },
                },
            ],
        },
        {
            path: '/blog',
            name: 'blog-overview',
            component: () => import('./views/Blog/BlogOverview.vue'),
            meta: {
                transitionName: 'slide',
                title: 'Blog - TaxiFusion',
                description: 'Neueste Einblicke und Updates von TaxiFusion',
            },
        },
        {
            path: '/blog/category/:category',
            name: 'blog-category',
            component: () => import('./views/Blog/BlogOverview.vue'),
            props: true,
            meta: {
                transitionName: 'slide',
                title: 'Blog Kategorie - TaxiFusion',
            },
        },
        {
            path: '/blog/search',
            name: 'blog-search',
            component: () => import('./views/Blog/BlogOverview.vue'),
            props: (route) => ({ query: route.query.q }),
            meta: {
                transitionName: 'slide',
                title: 'Suchergebnisse - TaxiFusion Blog',
            },
        },
        {
            path: '/blog/:slug',
            name: 'blog-post',
            component: () => import('./views/Blog/BlogPost.vue'),
            props: true,
            meta: {
                transitionName: 'slide',
                title: 'Blog Beitrag - TaxiFusion',
            },
        },
        {
            path: '/404',
            name: '404',
            component: () => import('./views/404.vue'),
            meta: {
                transitionName: 'slide',
            },
        },
        {
            path: '*',
            redirect: '/404',
        },
    ],
});

router.beforeEach(async (to, from, next) => {
    const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
    if (requiresAuth && !isAuthenticated()) {
        return next({
            path: '/sign-in',
            query: { redirect: to.fullPath },
        });
    } else {
        next();
    }
});

router.onError((error) => {
    const pattern =
        /Loading chunk (\d)+ failed|Loading CSS chunk (\d)+ failed|Failed to fetch dynamically imported module|Importing a module script failed/i;
    const isChunkLoadError = error.message && pattern.test(error.message);

    if (isChunkLoadError) {
        const currentPath = router.currentRoute.fullPath;
        sessionStorage.setItem('pendingReloadPath', currentPath);
        window.location.reload();
    }
});

router.afterEach((to, from) => {
    trackPageView(to.name || to.path, {
        from_page: from.name || from.path,
        user_authenticated: isAuthenticated(),
        route_meta: to.meta,
    });

    if (from.name && to.name && from.name !== to.name) {
        trackNavigation.routeChange(from.name, to.name, isAuthenticated());
    }

    if (to.name === 'blog-search' && to.query.q) {
        trackContent.blogSearch(to.query.q, null);
    }
});

export default router;
